import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { withReduxStateSync } from 'redux-state-sync';

import callsReducer from './calls';
import chainsReducer from './chains';
import dialerReducer from './dialer';
import emailsReducer from './emails';
import generalReducer from './general';
import logsReducer from './log';
import searchReducer from './search';
import ticketsReducer from './tickets';
import suggestReducer from './suggest';
import statisticReducer from './statistic';
import tasksReducer from './tasks';
import notificationsReducer from './notifications';
import b2bOrdersReducer from './b2bOrders';
import b2bLeadsReducer from './b2bLeads';
import b2bClientsReducer from './b2bClients';
import b2bTeamReducer from './b2bTeam';
import appModeReducer from './appMode';
import agentAuthReducer from './agentAuth';

const createRootReducer = ({ history }) =>
  withReduxStateSync(
    combineReducers({
      calls: callsReducer,
      chains: chainsReducer,
      dialer: dialerReducer,
      emails: emailsReducer,
      general: generalReducer,
      logs: logsReducer,
      router: connectRouter(history),
      search: searchReducer,
      tickets: ticketsReducer,
      suggest: suggestReducer,
      statistic: statisticReducer,
      tasks: tasksReducer,
      notifications: notificationsReducer,
      b2bOrders: b2bOrdersReducer,
      b2bLeads: b2bLeadsReducer,
      b2bClients: b2bClientsReducer,
      b2bTeam: b2bTeamReducer,
      appMode: appModeReducer,
      agentAuth: agentAuthReducer,
    })
  );

export default createRootReducer;
